
// TODO: May be we need clean "query" on init in edit mode, or implement other mechanic;

import { Component, Prop, Vue } from "vue-property-decorator";
import { convertSocItemForTable, TSocItem_Table, API_TSocItem } from "@/models/soc_items";

const MESSAGES = {
  columns: {
    socCode: "SOC code",
    socType: "SOC type",
  },
};
@Component({
  components: {
    SocTableItem: () => import("@/components/SocTable/SocTableItem.vue"),
  },
})
export default class SocTable extends Vue {
  @Prop({ type: String }) readonly value?: string;
  @Prop({ type: Array, default: () => [] }) readonly items?: API_TSocItem[];
  @Prop({ type: String }) readonly preselected?: string;

  messages = MESSAGES;

  get convertedItems(): TSocItem_Table[] {
    if (!this.items) return [];

    return this.items.map((item: API_TSocItem) => convertSocItemForTable(item));
  }

  isPreselected(item: TSocItem_Table) {
    return !!(this.preselected && this.preselected === item.soc_code);
  }

  selected: TSocItem_Table | null = null;

  select(payload: TSocItem_Table): void {
    this.selected = payload;

    this.$emit("input", payload.soc_code.toString());
  }

  isSelected(payload: TSocItem_Table): boolean {
    if (this.isPreselected(payload)) return true;

    if (!this.selected) return false;

    return this.selected.soc_code === payload.soc_code;
  }
}
